export default __webpack_public_path__ + "img/application.955bf1ce.svg";